export default __webpack_public_path__ + "static/media/NF.d0dc5e07.svg";